<template>
  <div class="order-list-wrap">
    <div class="order-table-header" v-if="!releation">
      <div
        v-for="(item, idx) in tableColumns" :key="'table' + idx"
        :class="`col ${item.class}`"
      >
        {{ item.label }}
      </div>
    </div>
    <!-- 订单卡片 -->
    <div :class="'order-table-list'" :style="`height: ${!releation ? tableHeight : 160}px`">
      <div :class="`order-table-colunm ${scoperow.offline_subsidy_order ? 'offline_subsidy_order' : ''}`" v-for="(scoperow) in tableData || []" :key="scoperow.order_id">
        <div class="order-meta">
          <!-- 标签 -->
          <template v-if="scoperow?.extInfo?.normal_gift_goods_type != 'gift_services'">
            <el-tag effect="dark" type="warning" size="mini" v-if="scoperow.order_status === 'NOTPAY'">待付款</el-tag>
            <el-tag effect="dark" type="" size="mini" v-else-if="scoperow.order_status === 'PAYED' && scoperow.pay_type !== 'appointment'">
              <span v-if="scoperow.receive_status !== '0'">{{ scoperow.order_status_msg }}</span>
              <span v-else-if="scoperow.receive_status === '0'">待接单</span>
              <span v-else>已付款</span>
            </el-tag>
            <el-tag effect="dark" size="mini" v-else-if="scoperow.order_status === 'WAIT_BUYER_CONFIRM' && scoperow.cancel_status === 'NO_APPLY_CANCEL'">
              {{ scoperow.order_status_msg }}
            </el-tag>
            <el-tag effect="dark" type="danger" size="mini" v-else-if="scoperow.order_status === 'CANCEL'">
              {{ scoperow.order_status_msg }}
            </el-tag>
            <el-tag effect="dark" size="mini" v-else>{{ scoperow.order_status_msg }}</el-tag>
            <el-tag effect="dark" type="warning" size="mini" v-if="scoperow.delivery_corp_source == 'SF_API_ERROR' || scoperow.delivery_corp_source == 'SF_API_CHEXIAO'">快递异常</el-tag>
            <el-tag effect="dark" type="danger" size="mini" v-if="scoperow.order_lock">订单锁定</el-tag>
            <el-tag effect="dark" type="warning" size="mini" v-if="scoperow?.extInfo?.normal_gift_goods_type == 'gift_services'"> {{ scoperow.order_status_msg }}</el-tag>
          </template>
          <template v-else>
            <el-tag type="warning" size="mini"> {{ scoperow.order_status_msg }}
            </el-tag>
          </template>
          <span class="order-no">订单编号：{{scoperow?.extInfo?.is_country_order == 2 ? scoperow?.customer_order_code : scoperow.order_id}}</span>
          <el-link type="primary" :underline="false" class="detail-link">
            <i v-clipboard:copy="scoperow?.extInfo?.is_country_order == 2 ? scoperow?.customer_order_code : scoperow.order_id" v-clipboard:success="onCopy">复制</i>
          </el-link>
          <span class="shop-info">门店：{{scoperow?.distributor_name}}（Apple ID {{scoperow?.distributor_info?.shop_code}}）</span>
          <!-- <span class="shop-info" v-if="scoperow.receipt_type === 'ziti'">门店电话：{{ scoperow?.distributor_info?.mobile || '暂无' }}</span>
          <span class="shop-info" v-if="scoperow.receipt_type === 'ziti'">门店地址：{{ scoperow?.distributor_info?.city + scoperow?.distributor_info?.area + scoperow?.distributor_info?.address }}</span> -->
          <span class="order-time">下单时间：{{ scoperow.create_time | datetime('yyyy-MM-dd hh:mm:ss') }}</span>
        </div>
        <div class="order-table-row">
          <!-- 商品信息 -->
          <div class="col col-product product-list-scroll">
            <div class="product-list">
              <div class="product-item" v-for="(goodsitem, idx) in scoperow.items" :key="'item' + idx">
                <el-image :src="goodsitem.pic" fit="fill" class="product-img"></el-image>
                <el-popover placement="top" trigger="hover" :content="goodsitem.item_name">
                  <div class="product-title" slot="reference">{{ goodsitem.item_name }}</div>
                </el-popover>
                <div class="product-price">{{ goodsitem.fee_symbol }} {{ goodsitem.total_fee / 100 }}</div>
              </div>
            </div>
          </div>
          <!-- 实收金额 -->
          <div class="col col-amount">
            <div class="pay-amount"><span class="cur">{{ scoperow.fee_symbol }}</span>{{ scoperow.total_fee / 100 }}</div>
            <el-link type="primary" :underline="false" class="detail-link" @click="showGoodsDetail(scoperow)">查看明细</el-link>
          </div>
          <!-- 收货信息 -->
          <div class="col col-receiver"><!-- v-if="scoperow?.extInfo?.normal_gift_goods_type != 'gift_services'"-->
            <div>
              {{scoperow.receipt_type === 'logistics' ? '收货人：' : '取货人：'}}
              {{ scoperow.receiver_name }}
              <PiiInfo pageType='1' memberType='receiver_name' optionScene="order_list"  :associatedId='scoperow.order_id'/>
            </div>
            <div>
              手机号：
              {{ scoperow.receiver_mobile }}
              <PiiInfo pageType='1' memberType='receiver_mobile' optionScene="order_list"  :associatedId='scoperow.order_id'/>
            </div>
            <div v-if="scoperow.receipt_type === 'logistics'">
              收货地址：
              <span>{{ scoperow.receiver_city + scoperow.receiver_district + scoperow.receiver_address }}</span>
              <PiiInfo pageType='4' memberType='receiver_address' optionScene="order_list" :associatedId='scoperow.order_id'/>
            </div>
          </div>
          <!-- 发货方 -->
          <div class="col col-sender">
            <template >
              <el-tag v-if="scoperow.is_warehouse == '0'" type="warning" plain size="mini">门店</el-tag>
              <el-tag v-if="scoperow.is_warehouse == '1' || scoperow.is_warehouse == '2'" type="info" plain size="mini">仓库</el-tag>
              <el-popover :key="scoperow.order_id"  placement="right" v-if="scoperow.show_oms_delivery === true" width="200" trigger="click">
                <div>
                  <div><span>发货点编码：</span><span style="color:#409EFF;">{{ scoperow?.extInfo?.oms_deliver_info.whCode }}</span></div>
                  <div><span>发货点名称：</span><span style="color:#409EFF;">{{ scoperow?.extInfo?.oms_deliver_info.whName }}</span></div>
                </div>
                <el-tag type="text" slot="reference" size="mini" >OMS发货信息</el-tag>
              </el-popover>
            </template>
          </div>
          <!-- 配送方式 -->
          <div class="col col-delivery">
            <template>
              <div style='display: flex; ;align-items: center;'>
                <span v-if="scoperow.receipt_type === 'ziti'">到店自取</span>
                <span v-if="scoperow.receipt_type === 'logistics'">快递</span>
                <span v-if="scoperow.receipt_type === 'directly'">直接发放</span>
                <el-link v-if="scoperow.receipt_type !== 'ziti' && scoperow.sf_response && scoperow.sf_response.length > 0" type="primary" :underline="false" class="detail-link" @click="showSFDetail(scoperow)">查看</el-link>
              </div>
              <div v-if="scoperow.receipt_type !== 'ziti'">
              </div>
              <el-popover v-if="scoperow.receipt_type !== 'ziti'" placement="bottom" width="200" trigger="click" :content="scoperow.order_pre_type">
                <el-tag type="success" slot="reference" size="mini" plain>{{ scoperow.order_pre_type.length > 5 ? scoperow.order_pre_type.substring(0, 5) + '...' : scoperow.order_pre_type }}</el-tag>
              </el-popover>
              <el-popover :key="scoperow.order_id" v-if="scoperow.receipt_type !== 'ziti'" placement="right" width="200" trigger="click">
                <div v-if="scoperow?.extInfo?.delivery_info">
                  <div><span>配送员姓名：</span><span>{{ scoperow?.extInfo?.delivery_info.courierName }}</span></div>
                  <div><span>配送员电话：</span><span>{{ scoperow?.extInfo?.delivery_info.courierPhone }}</span></div>
                </div>
                <el-tag v-if="scoperow?.extInfo?.delivery_info && scoperow?.extInfo?.delivery_info.courierName" type="text" slot="reference" size="mini">配送人员</el-tag>
              </el-popover>
            </template>
          </div>
          <!-- 订单渠道 -->
          <div class="col col-type">
            <el-tag type="info" size="mini" v-if=!checkStatus(scoperow.lingzhi_scene)>普通</el-tag>
            <el-tag type="success" size="mini" v-if=checkStatus(scoperow.lingzhi_scene)>企业微信</el-tag>
          </div>
          <!-- 订单标签 -->
          <div class="col col-tags">
            <div>
              <el-tag size="mini" v-if="checkPreOrderQh(scoperow)">期货预售</el-tag>
              <el-tag type="success" size="mini" v-if="eduDiscountLabel(scoperow)">{{ eduDiscountLabel(scoperow) }}</el-tag>
              <!-- <el-tag type="success" size="mini" v-if="scoperow.send_oms == 'true'">互道</el-tag> -->
              <el-tag type="success" size="mini" v-if="scoperow.tcb_status >= 1">以旧换新</el-tag>
              <el-tag type="warning" v-if="scoperow.ecid !== ''" size="mini">员工购</el-tag>
              <el-tag type="success" v-if="scoperow.use_full_gift === '1'" effect="dark" size="mini">满赠</el-tag>
              <el-tag type="warning" v-if="checkMinusPromotion(scoperow)" effect="dark" size="mini">满减</el-tag>
              <el-tag v-if="scoperow.order_tier === 'acplus'" effect="dark" size="mini">AC+</el-tag>
              <el-tag v-if="scoperow.order_tier === 'acs'" effect="dark" size="mini">ACS</el-tag>
              <el-tag v-if="scoperow.tcb_status >= 1 && scoperow.tradein_service_type == 1" size="mini">一站式回收</el-tag>
              <el-tag v-if="scoperow.tcb_status >= 1 && scoperow.tradein_service_type == 2" size="mini">上门回收</el-tag>
              <el-tag v-if="scoperow.tcb_status >= 1 && scoperow.tradein_service_type == 3" size="mini">旧机邮寄</el-tag>
              <el-tag size="mini" type="success" v-if="scoperow.pcredit_status && scoperow.pcredit_installment_num > 0">{{ scoperow.pcredit_installment_num }}期免息</el-tag>
              <el-tag size="mini" v-if="scoperow.type == '0'">普通订单</el-tag>
              <el-tag type="warning" size="mini" v-if="checkPreOrder(scoperow)">预售订单</el-tag>
              <el-tag size="mini" v-if="scoperow.is_bundle_discount == '1'">优惠搭售</el-tag>
              <el-tag size="mini" type="warning" v-if="scoperow.order_tier == 'normal_gift' && scoperow?.extInfo?.normal_gift_goods_type != 'gift_services'">实物赠品</el-tag>
              <el-tag size="mini" type="warning" v-if="scoperow.order_tier == 'normal_gift' && scoperow?.extInfo?.normal_gift_goods_type == 'gift_services'">虚拟赠品</el-tag>
              <el-tag size="mini" v-if="scoperow?.extInfo?.has_normal_gift_order == '1'">买X赠Y</el-tag>
              <el-tag type="success" v-if="scoperow?.extInfo?.is_country_order == 1" size="mini">国补</el-tag>
              <el-tag type="success" v-if="scoperow?.extInfo?.is_country_order == 2" size="mini">线下单</el-tag>
              <el-tag type="success" v-if="scoperow?.deposit_order == 1" size="mini">预付金</el-tag>
              <el-tag size="mini" v-if="scoperow?.extInfo?.is_crm_member == '1'">CRM会员单</el-tag>
              <el-tag size="mini" type="warning" v-if="scoperow.is_gifting_order == '1'">送礼</el-tag>
            </div>
          </div>
          <!-- 操作 -->
          <div class="col col-actions">
            <slot name="action-btn" :scoperow="scoperow"></slot>
          </div>
        </div>
        <slot name="releation-order" :scoperow="scoperow"></slot>
        <div class="order-relation-bar" v-if="scoperow.offline_subsidy_order">
          <div class="relation-dot"></div>
          <div class="relation-line"></div>
          <div class="relation-label">关联订单</div>
          <div class="relation-line"></div>
          <div class="relation-dot"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PiiInfo from '@/components/piiInfo/index'
import { useDialog } from '@shopex/finder'
export default {
  name: 'OrderColumn',
  components: {
    PiiInfo,
  },
  props: {
    tableData: {
      default: [],
      type: Array
    },
    releation: {
      default: false,
      type: Boolean
    },
    tableHeight: {
      default: 563,
      type: Number
    }
  },
  data() {
    return {
      tableColumns: [
        {
          label: '商品信息',
          prop: 'product',
          class: 'col-product'
        },
        {
          label: '实收金额',
          prop: 'amount',
          class: 'col-amount'
        },
        {
          label: '收货人',
          prop: 'receiver',
          class: 'col-receiver'
        },
        {
          label: '发货方',
          prop: 'sender',
          class: 'col-sender'
        },
        {
          label: '配送方式',
          prop: 'delivery',
          class: 'col-delivery'
        },
        {
          label: '订单渠道',
          prop: 'type',
          class: 'col-type'
        },
        {
          label: '订单标签',
          prop: 'tags',
          class: 'col-tags'
        },
        {
          label: '操作',
          prop: 'actions',
          class: 'col-actions'
        }
      ],
    }
  },
  methods: {
    eduDiscountLabel(row) {
      if (!row || row.xxw_check_code === '' || row.xxw_check_code == null) {
        return ''
      }
      return row.edu_customer_type === 'teacher' ? '教育优惠【教师】' : '教育优惠【学生】'
    },
    showGoodsDetail (row) {
      useDialog(null, {
        title: `查看`,
        width: '70%',
        component: () => import('./goodsList.vue'),
        data: row.items,
        actions: []
      })
    },
    checkStatus(source) {
      if (!source) {
        return false;
      }
      if (source == null) {
        return false;
      }
      if (source == '') {
        return false;
      }
      return true
    },
    checkMinusPromotion(row) {
      let show = false
      let discount = row.discount_info ? JSON.parse(row.discount_info) : ''
      console.log(discount)
      for (let item in discount) {
        if (discount[item].type === 'full_minus') {
          show = true
        }
      }
      console.log('dassffsdad', show)
      return show
    },
    checkPreOrderQh(row) {
      if (row.type == '2') {
        let qh = row.extInfo.pre_call_delivery === 1 ? true : false
        if (qh) {
          return true;
        }
        return false;
      }
      return false
    },
    checkPreOrder(row) {
      if (row.type == '2') {
        let qh = row.extInfo.pre_call_delivery === 1 ? true : false
        if (qh) {
          return false;
        }
        return true;
      }
      return false
    },
    onCopy() {
      this.$notify({
        message: '复制成功',
        type: 'success',
      })
    },
    showSFDetail (row) {
      useDialog(null, {
        title: `查看`,
        width: '70%',
        component: () => import('./sfRecordlist.vue'),
        data: row,
        actions: []
      })
    },
  },
  mounted () {
  }
}
</script>

<style lang="scss" src="./listColumn.scss"></style>
